import React from 'react';
import { TextFieldProps } from 'mui-rff';
import { onlyNumbers } from 'utils/formatters';

import Input from '../Input';

const PhoneInput = ({ fieldProps, ...props }: TextFieldProps) => (
  <Input
    type="tel"
    fieldProps={{
      format: (value: string) => (onlyNumbers(value)),
      parse: (value:string) => (onlyNumbers(value)),
      ...fieldProps,
    }}
    {...props}
  />
);

export default PhoneInput;
